import { useCallback, useEffect, useRef } from 'react';

// ResizeObserver can call scroll handlers before paint. Apply DOM changes in
// the next frame so they cannot trigger another layout inside that notification.
export default function useAnimationFrameCallback(callback) {
  const frame = useRef(null);
  const pendingArgs = useRef(null);

  const schedule = useCallback((...args) => {
    pendingArgs.current = args;
    if (frame.current !== null) return;
    frame.current = window.requestAnimationFrame(() => {
      frame.current = null;
      callback(...pendingArgs.current);
      pendingArgs.current = null;
    });
  }, [callback]);

  useEffect(() => () => {
    if (frame.current !== null) window.cancelAnimationFrame(frame.current);
    frame.current = null;
    pendingArgs.current = null;
  }, [callback]);

  return schedule;
}
